module.exports = __webpack_public_path__ + "img/note.6e7915e2.png";